import {
  getModule,
  Module,
  Mutation,
  Action,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import User from "@/lib/model/user/user";
import Company from "@/lib/model/company/company";
import CandidateListForm from "@/lib/form/candidate/CandidateListForm";
import { AiPermission } from "@/lib/model/common";
import { CompanySpecialConfig } from "@/lib/model/exam/candidate-answer";
import { CompanySpecialConfigNew } from "@/lib/model/exambuilder/exam-component/company";

export enum EnumEditStatus {
  EnumInit,
  EnumDelete,
  EnumInsert
}

@Module({
  name: "vuexStore",
  dynamic: true,
  namespaced: true,
  store
})
class VuexStore extends VuexModule {
  public user = new User();
  public company = new Company();
  public companies: Company[] = [];

  public isGetUser = false;
  public isGetCompany = false;
  public isGetCompanies = false;
  public showCompany = false; //公司卡片
  public sideIsCollapse = true; //侧边栏是否收起
  public P = new AiPermission(); //用户权限
  public candidateParams = new CandidateListForm(); //候选人页 筛选条件
  public AiStep = { step: 0, show: false }; //AIbuilder 进度条
  public isNewAi = true; //是否新AIbuilder
  public isWorker = false; //Aibuilder下的 普工版
  public companyPower = new CompanySpecialConfig(); //公司权限
  public companyPower15 = new CompanySpecialConfigNew(); //公司权限

  public keepAlivePages: string[] = []; // 保持缓存的组件名
  public editStatus: EnumEditStatus = EnumEditStatus.EnumInit; // 面试详情页改变的状态

  @Mutation
  public SETEDITSTATUS(status: EnumEditStatus) {
    this.editStatus = status;
  }

  @Action({ commit: "SETEDITSTATUS" })
  public setEditStatus(status: EnumEditStatus) {
    return status;
  }

  @Mutation
  public ADDKEEPALIVE(componentName: string) {
    if (!this.keepAlivePages.includes(componentName)) {
      this.keepAlivePages.push(componentName);
    }
  }

  @Mutation
  public REMOVEKEEPALIVE(componentName: string) {
    const i = this.keepAlivePages.findIndex(str => str === componentName);
    if (i >= 0) {
      this.keepAlivePages.splice(i, 1);
    }
  }

  @Action({ commit: "ADDKEEPALIVE" })
  public addPages(componentName: string) {
    return componentName;
  }

  @Action({ commit: "REMOVEKEEPALIVE" })
  public removePages(componentName: string) {
    return componentName;
  }

  @Mutation
  public USER(user: User) {
    this.user = user;
    this.isGetUser = true;
  }

  @Action({ commit: "USER" })
  public updateUser(user: User) {
    return user;
  }

  @Mutation
  public COMPANY(company: Company) {
    this.company = company;
    this.isGetCompany = true;
  }

  @Action({ commit: "COMPANY" })
  public updateCompany(company: Company) {
    return company;
  }

  @Mutation
  public COMPANIES(companies: Company[]) {
    this.companies = companies;
    this.isGetCompanies = true;
  }

  @Action({ commit: "COMPANIES" })
  public updateCompanies(companies: Company[]) {
    return companies;
  }

  @Mutation
  public SHOWCOMPANY(showCompany: boolean) {
    this.showCompany = showCompany;
  }

  @Action({ commit: "SHOWCOMPANY" })
  public updateShowCompany(showCompany: boolean) {
    return showCompany;
  }

  @Mutation
  public SIDEISCOLLAPSE(sideIsCollapse: boolean) {
    this.sideIsCollapse = sideIsCollapse;
  }

  @Action({ commit: "SIDEISCOLLAPSE" })
  public updateSideIsCollapse(sideIsCollapse: boolean) {
    return sideIsCollapse;
  }
  //用户权限
  @Mutation
  public PERMISSION(p: AiPermission) {
    this.P = p;
  }
  @Action({ commit: "PERMISSION" })
  public updatePermission(p: AiPermission) {
    return p;
  }
  //候选人列表参数
  @Mutation
  public CANDIDATEPARAMS(p: CandidateListForm) {
    this.candidateParams = p;
  }
  @Action({ commit: "CANDIDATEPARAMS" })
  public updateCandidateParams(p: CandidateListForm) {
    return p;
  }
  //AI builder 进度条
  @Mutation
  public AIBUILDERSTEP(p: any) {
    this.AiStep = p;
  }
  @Action({ commit: "AIBUILDERSTEP" })
  public updateAiStep(p: any) {
    return p;
  }
  //是否走 AI builder
  @Mutation
  public ISNEWAI(p: any) {
    this.isNewAi = p;
  }
  @Action({ commit: "ISNEWAI" })
  public updateIsNewAi(p: any) {
    return p;
  }
  //是否普工版 AIbuilder
  @Mutation
  public ISWORKER(p: boolean) {
    this.isWorker = p;
  }
  @Action({ commit: "ISWORKER" })
  public updateIsWorker(p: boolean) {
    return p;
  }
  //公司权限
  @Mutation
  public COMPANYPOWER(p: CompanySpecialConfig) {
    this.companyPower = p;
  }
  @Action({ commit: "COMPANYPOWER" })
  public updateCompanyPower(p: CompanySpecialConfig) {
    return p;
  }

  //公司权限1.5
  @Mutation
  public COMPANYPOWER15(p: CompanySpecialConfigNew) {
    this.companyPower15 = p;
  }
  @Action({ commit: "COMPANYPOWER15" })
  public updateCompanyPower15(p: CompanySpecialConfigNew) {
    return p;
  }

  //判断类型 接口入参用
  public get getExamType() {
    const ding = document.URL.indexOf("-dingtalk") !== -1;
    return ding
      ? "dingding"
      : !this.isNewAi
      ? ""
      : this.isWorker
      ? "aiworker"
      : "aibuilder";
  }
}

export default getModule(VuexStore);
